<template>
  <span>
    {{price_arr[0]}} руб. <sup class="price-decimal-sup" v-if="price_arr[1]">{{ price_arr[1] }} коп.</sup> 
  </span>
</template>

<script>
  export default  {
    props: {
      value: {
        required: true
      }
    },
    computed : {
      price_arr() {
        return this.format_price(this.value, true)
      }
    }
  }
</script>
